import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-right: 20px;
  padding-top: 2px;
  > button {
    display: flex;
    align-items: center;
    flex-direction: row;
    border: none;
    background: none;
    color: #74a50a;
    font-weight: bold;
  }
`;
